export default {
  // 画板块
  async drawArea(currentMap) {
    let that = this;
    let areaList = await that.getAreas("板块");
    for (let i = 0; i < areaList.length; i++) {
      let temp = areaList[i];
      if (!temp.dots) {
        continue;
      }

      //板块区域
      let dots = temp.dots.split("-").map((x) => {
        return x.split("|");
      });
      let polygon = new AMap.Polygon({
        path: dots,

        fillOpacity: 0,
        fillColor: "#CCF3FF",

        strokeWeight: 1,
        strokeOpacity: 1,
        strokeColor: "#CC66CC",
      });
      currentMap.add(polygon);

      // 板块价格板块名
      let markerContent = `
            <div class="areaName1">
              <div>${temp.area_name}</div>
            </div>
            `;

      let marker = new AMap.Marker({
        position: temp.center.split("|"),
        content: markerContent,
        offset: new AMap.Pixel(-20, -15),
        draggable: true,
      });

      marker.setMap(currentMap);
    }
  },

  async drawAreaPriceNew(currentMap, xType) {
    let that = this;

    let areaList = await that.getAreas("板块");
    // areaList.sort((a,b) => {
    //   return (b.hot || 0) - (a.hot || 0);
    // })
    // console.log('areaList', areaList);
    for (let i = 0; i < areaList.length; i++) {
      let temp = areaList[i];
      if (!temp.dots) {
        continue;
      }

      //板块区域
      let fillColor = "#ff0000";
      let fillOpacity = 0.1;
      // if (type == '中签率') {
      //   fillColor = '#f7c1fe';
      //   fillOpacity = 0.6;
      //   let rate = parseFloat(temp.sum_data && temp.sum_data.zql);
      // }
      let dots = temp.dots.split("-").map((x) => {
        return x.split("|");
      });
      let polygon = new AMap.Polygon({
        path: dots,

        fillOpacity: 0.1,
        fillColor: "#808080",

        strokeWeight: 1,
        strokeOpacity: 1,
        strokeColor: "black",
      });
      currentMap.add(polygon);

      // 板块价格板块名
      let markerContent = "";
      let minPrice = temp.id;
      if (!that.myObject[minPrice]) {
        markerContent = `
            <div class="areaName1">
              <div>${temp.area_name}</div>
            </div>
          `;
      } else {
        if (minPrice) {
          if (xType === "企业") {
            minPrice = that.myObject[minPrice].length + "个企业";
          } else if (xType === "大厦") {
            minPrice = that.myObject[minPrice].length + "栋大厦";
          } else if (xType === "楼盘点击") {
            let array = that.myObject[minPrice];
            let sum = 0;
            for (let i = 0; i < array.length; i++) {
              let a = array[i].count;
              sum += a;
            }
            minPrice = sum + "次点击";
          } else if (xType === "楼盘中签率") {
            let array = that.myObject[minPrice];
            let max = 0;
            for (let i = 0; i < array.length; i++) {
              let a = array[i].count;
              if (max < a) {
                max = a;
              }
            }
            minPrice = "区域中签率最高" + max + "%";
          }
          markerContent = `
              <div class="areaName1">
                <div>${temp.area_name}</div>
                <div>${minPrice}</div>
              </div>
            `;
        }
      }

      let marker = new AMap.Marker({
        position: temp.center.split("|"),
        content: markerContent,
        offset: new AMap.Pixel(-20, -15),
        // draggable: true
      });

      marker.setMap(currentMap);
    }
  },

  async drawAreaPrice(currentMap, type) {
    let that = this;
    let areaList = await that.getAreas("板块");
    areaList.sort((a, b) => {
      return (b.hot || 0) - (a.hot || 0);
    });
    console.log("areaList", areaList);
    for (let i = 0; i < areaList.length; i++) {
      let temp = areaList[i];
      if (!temp.dots) {
        continue;
      }

      //板块区域
      let fillColor = "#ff0000";
      let fillOpacity = 0.1;
      if (type == "中签率") {
        fillColor = "#f7c1fe";
        fillOpacity = 0.6;
        let rate = parseFloat(temp.sum_data && temp.sum_data.zql);
        if (rate) {
          temp.area_name = temp.area_name + rate + "%";
          if (rate < 2) {
            fillColor = "#bc02d7";
          } else if (rate < 11) {
            fillColor = "#e63eff";
          } else if (rate < 51) {
            fillColor = "#f085ff";
          }
        }
      } else if (type === "热度") {
        let hot = temp.hot || 0;
        if (hot < 6) {
          fillOpacity = 0.5;
        } else if (hot < 25) {
          fillOpacity = 0.35;
        } else if (hot < 60) {
          fillOpacity = 0.2;
        }
      }
      let dots = temp.dots.split("-").map((x) => {
        return x.split("|");
      });
      let polygon = new AMap.Polygon({
        path: dots,
        fillOpacity: fillOpacity,
        fillColor: fillColor,
        strokeWeight: 1,
        strokeOpacity: 1,
        strokeColor: "#CC66CC",
      });
      currentMap.add(polygon);

      // 板块价格板块名
      let markerContent = "";
      let minPrice = temp.new_price;
      if (minPrice) {
        minPrice = (minPrice / 10000).toFixed(2) + "万";
        markerContent = `
              <div class="areaName1">
                <div>${temp.area_name}</div>
                <div>${minPrice}/m²</div>
              </div>
              `;
      } else {
        markerContent = `
              <div class="areaName1">
                <div>${temp.area_name}</div>
              </div>
              `;
      }

      let marker = new AMap.Marker({
        position: temp.center.split("|"),
        content: markerContent,
        offset: new AMap.Pixel(-20, -15),
        draggable: true,
      });

      marker.setMap(currentMap);
    }
  },

  async drawAreaPrice1(currentMap) {
    let that = this;
    let areaList = await that.getAreas("板块");
    for (let i = 0; i < areaList.length; i++) {
      let temp = areaList[i];
      if (!temp.dots) {
        continue;
      }

      //板块区域
      let dots = temp.dots.split("-").map((x) => {
        return x.split("|");
      });
      let polygon = new AMap.Polygon({
        zIndex: 180,
        path: dots,
        fillOpacity: 0,
        strokeWeight: 5,
        strokeOpacity: 1,
        strokeColor: "#808080",
      });
      currentMap.add(polygon);

      // 板块价格板块名
      let markerContent = "";
      let minPrice = temp.new_price;
      if (minPrice) {
        minPrice = (minPrice / 10000).toFixed(2) + "万";
        markerContent = `
              <div class="areaName2">
                <div>${temp.area_name}</div>
                <div class="light">${minPrice}/m²</div>
              </div>
              `;
      } else {
        markerContent = `
              <div class="areaName2">
                <div>${temp.area_name}</div>
              </div>
              `;
      }

      let marker = new AMap.Marker({
        position: temp.center.split("|"),
        content: markerContent,
        offset: new AMap.Pixel(-40, -30),
        draggable: true,
      });

      marker.setMap(currentMap);
    }
  },

  drawAreaNew(currentMap, isSub) {
    // 板块数据不需要的不要拿
    let that = this;
    let bgc = ["#ea78fe", "#a67ffd", "#496bff", "#7abfff", "#7df6fd"];

    that.$axios
      .get(that.$url_prefix + "queryAreaByLevel", {
        params: {
          level: "板块",
          projection:
            "-_id id area_name district dots old_price new_price center kernel",
        },
      })
      .then(function (res) {
        console.log("所有板块", res);
        if (res.data.centerArea && that.type == "新房") {
          let centerdots = res.data.centerArea.split("-").map((x) => {
            return x.split("|");
          });
          console.log("主城区", centerdots);
          let polygon1 = new AMap.Polygon({
            // 范围线
            zIndex: -1,
            map: currentMap,
            path: centerdots,
            strokeOpacity: 1,
            fillColor: "#ff0000",
            strokeWeight: 5,
            strokeOpacity: 1,
            strokeColor: "transparent",
            fillOpacity: 0.3, // 填充透明度
          });
        }
        if (!isSub) {
          that.drawBaseCover(currentMap);
        }

        // let markerContent = '';

        for (let i = 0; i < res.data.data.length; i++) {
          let temp = res.data.data[i];
          if (!temp.dots) {
            continue;
          }
          if (!that.currentArea.includes("全城") && !isSub) {
            if (temp.district !== that.currentArea) {
              continue;
            }
          }
          let fillColor = bgc[4];

          // 板块价格板块名
          let minPrice = temp.new_price; // 新房价格

          let oldPrice = 0;
          if (temp.old_price) {
            oldPrice = parseInt(temp.old_price);
          }

          let judgePrice = 0;
          if (minPrice) {
            judgePrice = minPrice;
          } else if (oldPrice) {
            judgePrice = oldPrice;
          }
          if (judgePrice >= 50000) {
            fillColor = bgc[0];
          } else if (judgePrice >= 40000) {
            fillColor = bgc[1];
          } else if (judgePrice >= 30000) {
            fillColor = bgc[2];
          } else if (judgePrice >= 20000) {
            fillColor = bgc[3];
          }
          fillColor = "#e8e1c9";

          let newStr = "";
          let oldStr = "";
          if (minPrice && minPrice < 100000000) {
            newStr = "<div>新" + minPrice + "</div>";
          }
          if (oldPrice) {
            oldStr = "<div>二" + oldPrice + "</div>";
          }
          let markerContent = `
            <div class="areaName" style="background-color:${fillColor}">
              <div>${temp.area_name}</div>
              ${newStr}
            </div>
            `;

          // 板块区域
          let dots = temp.dots.split("-").map((x) => {
            return x.split("|");
          });
          let polygon = new AMap.Polygon({
            path: dots,

            fillOpacity: 0.6,
            // fillColor: '#CCF3FF',
            fillColor: "#ffffff",
            strokeWeight: 0.5,
            strokeOpacity: 1,
            strokeColor: "#bdbdbd",
          });
          currentMap.add(polygon);

          let center = temp.kernel || temp.center;
          let marker = new AMap.Marker({
            area_id: temp.id,
            position: center.split("|"),
            content: markerContent,
            offset: new AMap.Pixel(-20, -15),
            draggable: true,
          });

          if (!isSub) {
            marker.on("dragend", (e) => {
              console.log("移动结束", e);
              let area_id = e.target.w.area_id;
              let pos = e.target.getPosition();
              that.changeAreaCenter(area_id, pos.lng + "|" + pos.lat);
            });
          }

          marker.setMap(currentMap);
        }
      })
      .catch((res) => {
        console.log("query area fail", res);
      });
  },

  drawAreaNew2(currentMap, isSub) {
    // 板块数据不需要的不要拿
    let that = this;

    that.$axios
      .get(that.$url_prefix + "queryAreaByLevel", {
        params: {
          level: "板块",
          projection:
            "-_id id area_name district dots old_price new_price center kernel",
        },
      })
      .then(function (res) {
        console.log("所有板块", res);
        if (res.data.centerArea && that.type == "新房") {
          let centerdots = res.data.centerArea.split("-").map((x) => {
            return x.split("|");
          });
          console.log("主城区", centerdots);
          new AMap.Polygon({
            // 范围线
            zIndex: -1,
            map: currentMap,
            path: centerdots,
            strokeOpacity: 1,
            fillColor: "#ff0000",
            strokeWeight: 5,
            strokeOpacity: 1,
            strokeColor: "transparent",
            fillOpacity: 0.3, // 填充透明度
          });
        }
        if (!isSub) {
          that.drawBaseCover(currentMap);
        }

        for (let i = 0; i < res.data.data.length; i++) {
          let temp = res.data.data[i];
          if (!temp.dots) {
            continue;
          }
          if (!that.currentArea.includes("全城") && !isSub) {
            if (temp.district !== that.currentArea) {
              continue;
            }
          }

          // 板块价格板块名
          let minPrice = temp.new_price; // 新房价格
          let newStr = "";
          if (minPrice && minPrice < 100000000) {
            newStr = "<div>新" + minPrice + "</div>";
          }
          let markerContent = `
            <div class="areaName3">
              <div>${temp.area_name}</div>
              ${newStr}
            </div>
            `;

          // 板块区域
          let dots = temp.dots.split("-").map((x) => {
            return x.split("|");
          });
          let polygon = new AMap.Polygon({
            path: dots,

            fillOpacity: 0.6,
            // fillColor: '#CCF3FF',
            fillColor: "#ffffff",
            strokeWeight: 0.5,
            strokeOpacity: 1,
            strokeColor: "#bdbdbd",
          });
          currentMap.add(polygon);

          let center = temp.kernel || temp.center;
          let marker = new AMap.Marker({
            area_id: temp.id,
            position: center.split("|"),
            content: markerContent,
            offset: new AMap.Pixel(-20, -15),
            draggable: true,
          });

          if (!isSub) {
            marker.on("dragend", (e) => {
              console.log("移动结束", e);
              let area_id = e.target.w.area_id;
              let pos = e.target.getPosition();
              that.changeAreaCenter(area_id, pos.lng + "|" + pos.lat);
            });
          }

          marker.setMap(currentMap);
        }
      })
      .catch((res) => {
        console.log("query area fail", res);
      });
  },

  drawAreaOld(currentMap) {
    let that = this;
    let bgc = ["#2a2a2a", "#404140", "#6f706f", "#9b9b9b", "#c4c4c4"];

    that.$axios
      .get(that.$url_prefix + "getDB", {
        params: {
          dataContent: "WpAreaModel",
        },
      })
      .then(function (res) {
        console.log("所有板块", res);
        for (let i = 0; i < res.data.data.length; i++) {
          let temp = res.data.data[i];
          if (!temp.dots) {
            continue;
          }
          if (!that.currentArea.includes("全城")) {
            if (temp.district !== that.currentArea) {
              continue;
            }
          }
          let fillColor = bgc[4];

          // 板块价格板块名
          let markerContent = "";
          let minPrice = 100000000;
          if (temp.old_price) {
            minPrice = parseInt(temp.old_price);
          }
          if (minPrice < 100000000) {
            markerContent = `
              <div class="areaName">
                <div>${temp.area_name}</div>
                <div class="realPrice-c">${minPrice}/m²</div>
              </div>
              `;
            if (minPrice >= 50000) {
              fillColor = bgc[0];
            } else if (minPrice >= 40000) {
              fillColor = bgc[1];
            } else if (minPrice >= 30000) {
              fillColor = bgc[2];
            } else if (minPrice >= 20000) {
              fillColor = bgc[3];
            } else if (minPrice >= 10000) {
              fillColor = bgc[4];
            }
          } else {
            markerContent = `
              <div class="areaName">
                <div>${temp.area_name}</div>
              </div>
              `;
          }

          //板块区域
          let dots = temp.dots.split("-").map((x) => {
            return x.split("|");
          });
          let polygon = new AMap.Polygon({
            path: dots,

            fillOpacity: 0.6,
            // fillColor: '#CCF3FF',
            fillColor: fillColor,

            strokeWeight: 2,
            strokeOpacity: 1,
            // strokeColor: '#CC66CC'
            strokeColor: "#000000",
          });
          currentMap.add(polygon);

          let marker = new AMap.Marker({
            zIndex: 130,
            area_id: temp.id,
            position: temp.center.split("|"),
            content: markerContent,
            offset: new AMap.Pixel(-20, -15),
            draggable: true,
          });

          marker.setMap(currentMap);
        }
      })
      .catch((res) => {
        console.log("query area fail", res);
      });
  },
};



// WEBPACK FOOTER //
// ./src/page/makeLocationImage/methods/bindArea.js